module.exports = __webpack_public_path__ + "media/images/components/cms/question_and_answer_component/background_triangle-7e2cba377f7b1a5fbccbc2b55040e546.svg";